export default {
  colors: {
    primary: {
      orange: '#FF7D1A',
      paleOrange: '#FFEDE0',
    },
    neutral: {
      veryDarkBlue: '#1D2025',
      darkGrayishBlue: '#68707D',
      grayishBlue: '#B6BCC8',
      lightGrayishBlue: '#F7F8FD',
      white: '#FFFFFF',
      black: '#000000',
    },
  },
  typography: {
    bodyCopy: {
      fontSize: '1.6rem',
    },
    font: {
      family: 'Kumbh Sans',
      regular: 400,
      bold: 700,
    },
  },
};
